import React from 'react'

import Chip from 'components_new/atoms/Chip'
import Icon from 'components_new/atoms/Icon'
import TableCell from 'components_new/atoms/Table/TableCell'
import Tooltip from 'components_new/atoms/Tooltip'

import GenericListItem from 'components_new/molecules/GenericListItem'

import { Highlighted } from 'components_new/organisms/StandardSearch/utils'

import { translateMetricStatus } from 'utils/enumTranslator'

import { IMetric, isStandardMetric } from 'types/GlobalMetric'
import { TCoreWidgetSettingsLoaded } from 'types/GlobalWidget'

import { getShowUnitWarning } from './utils'
import { useTranslation } from 'language/translator'
import { useAllowAccessMetric } from 'redux/hooks/Permissions'

interface Props {
  metric: IMetric
  widget?: TCoreWidgetSettingsLoaded | null
  search: string | null
  category: string | null
}

const MetricTableRow = React.memo((props: Props) => {
  const { metric, widget, category, search } = props
  const { t, translateEnum, lang } = useTranslation()
  const allowed = useAllowAccessMetric(metric.id)

  const showUnitWarning = getShowUnitWarning(metric, widget)

  const configIncomplete = metric.config ? metric.config.incomplete : false
  const disabled = configIncomplete

  // success
  return (
    <>
      <Tooltip
        title={
          !allowed
            ? t('metrics', 'no_access')
            : configIncomplete
              ? t('global', 'missing_configuration')
              : undefined
        }
      >
        <TableCell padding="none">
          <GenericListItem
            body={isStandardMetric(metric) ? metric.summary[lang] : undefined}
            customTitle={
              <Highlighted text={metric.title[lang]} highlight={search} />
            }
            disablePadding={true}
            title={metric.title[lang]}
            titleIcon={
              disabled
                ? {
                    name: metric.access.private
                      ? 'Private'
                      : 'CrisisAlertTwoTone'
                  }
                : undefined
            }
            titleIconTooltip={
              metric.access.private
                ? t('metrics', 'is_private')
                : configIncomplete
                  ? t('metrics', 'requires_configuration')
                  : undefined
            }
            variant="metric"
          />
        </TableCell>
      </Tooltip>
      <Tooltip
        title={
          showUnitWarning ? (
            <>
              <b>{t('metrics', 'unit_mismatch')}</b>
              <br />
              <br />
              {t('metrics', 'unit_warning')}
            </>
          ) : undefined
        }
      >
        <TableCell>
          <Chip
            label={metric.unit ?? t('global', 'pcs')}
            size="xsmall"
            icon={
              showUnitWarning ? (
                <Icon name="Warning" fontSize="small" color="warning" />
              ) : undefined
            }
          />
        </TableCell>
      </Tooltip>
      <TableCell>
        <Chip
          label={
            category
              ? metric.subcategory.title[lang]
              : metric.category.title[lang]
          }
          size="xsmall"
        />
      </TableCell>
      <TableCell>
        <Chip
          color={translateMetricStatus[metric.status].color}
          label={translateEnum('metric_statuses', metric.status).title}
          size="xsmall"
        />
      </TableCell>
      <TableCell padding="checkbox">
        <Icon fontSize="small" name="ChevronRight" />
      </TableCell>
    </>
  )
})

export default MetricTableRow
